import React from "react";
import {
  Mark,
  Switch,
  Text,
  Tooltip,
  useColorModeValue,
  useTheme,
} from "@chakra-ui/react";


const CustomizeAIPreviewSwitch = ({ title, description, value, isDisabled }) => {
  const theme = useTheme();
  const textColor = useColorModeValue(theme.colors.lightText, theme.colors.darkText);

  return (
    <>
      <Tooltip
        label={description}
        placement="top-start">
        <Text fontSize="sm" mt={2}>
          <Mark
            color={textColor}
            as="span"
            bgColor={value && "yellow.200"}>
            {title}
          </Mark>
        </Text>
      </Tooltip>
      <Switch
        isChecked={!!value}
        isDisabled={isDisabled}
      />
    </>
  )
};

export default CustomizeAIPreviewSwitch;
